// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { getDoc, setDoc } from "firebase/firestore";
import { getAuth } from 'firebase/auth';


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// console.log('[firebase] Config:', firebaseConfig);

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const addTagToThought = async (thoughtId, tag) => {
  const thoughtRef = doc(db, 'thoughts', thoughtId);
  await updateDoc(thoughtRef, {
    tags: arrayUnion(tag.toLowerCase()),
  });
};

export const loadUserThreads = async (uid) => {
  const userSettingsRef = doc(db, 'users', uid, 'settings', 'general');
  const userSettingsSnap = await getDoc(userSettingsRef);
  if (userSettingsSnap.exists()) {
    const data = userSettingsSnap.data();
    return data.threads || [];
  }
  return [];
};

export const saveUserThreads = async (uid, threads) => {
  // console.log('Saving threads for user:', uid, threads); // 👈 Add this line
  const userSettingsRef = doc(db, 'users', uid, 'settings', 'general');
  await setDoc(userSettingsRef, { threads }, { merge: true });
};